export default __webpack_public_path__ + "static/media/9.NODRIZAS.59a6aae1.jpg";